import http from '../../service/http/http';
import router from '../../router';
import store from '@/store';
import axios from 'axios';
import { API_IBGE } from '../../config/config';

const state = {
  cadastroLoading: false,
  cadastroErrors: [],
  mensagem: '',
  usuarioInfo: '',
  loadingCep: false,
  loadingMunicipios: false,
  MunicipiosInfo: [],
  loadingNomeUsuario: false,
  NomeUsuarioExists: null,
  loadingNumeroDocumento: false,
  NumeroDocumentoExists: null,
  ultimoTokenConfirmacaoPendente: null
};

const mutations = {
  SET_CADASTRO_LOADING: (state, value) => (value ? (state.cadastroLoading = value) : (state.cadastroLoading = false)),
  SET_CADASTRO_ERROR: (state, value) => (value ? (state.cadastroErrors = value) : (state.cadastroErrors = [])),
  SET_MENSAGEM: (state, value) => (value ? (state.mensagem = value) : (state.mensagem = '')),
  SET_USUARIO_INFO: (state, value) => (value ? (state.usuarioInfo = value) : (state.usuarioInfo = '')),
  SET_LOADING_CEP: (state, value) => (value ? (state.loadingCep = value) : (state.loadingCep = false)),
  SET_LOADING_MUNICIPIOS: (state, value) => (value ? (state.loadingMunicipios = value) : (state.loadingMunicipios = false)),
  SET_MUNICIPIOS_INFO: (state, value) => (value ? (state.MunicipiosInfo = value) : (state.MunicipiosInfo = [])),
  SET_NOME_USUARIO_LOADING: (state, value) => (value ? (state.loadingNomeUsuario = value) : (state.loadingNomeUsuario = false)),
  SET_NOME_USUARIO_EXISTS: (state, value) => (value ? (state.NomeUsuarioExists = value) : (state.NomeUsuarioExists = false)),
  SET_NUMERO_DOCUMENTO_LOADING: (state, value) => (value ? (state.loadingNumeroDocumento = value) : (state.loadingNumeroDocumento = false)),
  SET_NUMERO_DOCUMENTO_EXISTS: (state, value) => (value !== null ? (state.NumeroDocumentoExists = value) : (state.NumeroDocumentoExists = null)),
  SET_ULTIMO_TOKEN_CONFIRMACAO_PENDENTE: (state, value) => (state.ultimoTokenConfirmacaoPendente = value)
};

const getters = {
  getCadastroLoading: (state) => state.cadastroLoading,
  getCadastroError: (state) => state.cadastroErrors,
  getMensagem: (state) => state.mensagem,
  getUsuarioInfo: (state) => state.usuarioInfo,
  getLoadingCep: (state) => state.loadingCep,
  getLoadingMunicipios: (state) => state.loadingMunicipios,
  getMunicipiosInfo: (state) => state.MunicipiosInfo,
  getLoadingNomeUsuario: (state) => state.loadingNomeUsuario,
  getNomeUsuarioExists: (state) => state.NomeUsuarioExists,
  getLoadingNumeroDocumento: (state) => state.loadingNumeroDocumento,
  getNumeroDocumentoExists: (state) => state.NumeroDocumentoExists,
  getUltimoTokenConfirmacaoPendente: (state) => state.ultimoTokenConfirmacaoPendente
};

const actions = {
  async setCadastro({ commit, dispatch }, value) {
    if (state.cadastroLoading) return;

    commit('SET_CADASTRO_LOADING', true);
    return new Promise((resolve, reject) => {
      const payload = {
        Usuario: value
      };
      http
        .post('usuario/registrar', payload)
        .then(async (resp) => {
          commit('SET_CADASTRO_LOADING');
          commit('SET_CADASTRO_ERROR');
          commit('SET_MENSAGEM', '');
          if (store.state.login.auth?.profile.idp !== 'Google' && store.state.login.auth?.profile.idp !== 'Facebook') {
            router.push({ name: 'login', query: { cadastroConcluido: '1' } });
          } else {
            await dispatch('checkRegisterCompleted');
          }
          resolve(resp?.data?.data);
        })
        .catch(function (error) {
          commit('SET_CADASTRO_LOADING');

          const result = [];
          const errors = error?.response?.data?.Errors || error?.response?.data?.errors;
          if (errors) {
            for (var key in errors) {
              result.push(errors[key]);
            }
          } else if (error?.response?.data?.message) {
            result.push(error.response.data.message);
          } else if (typeof error === 'string') {
            result.push(error);
          }
          commit('SET_CADASTRO_ERROR', result);
          reject();
        });
    });
  },

  async info({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (!state.usuarioInfo && !state.cadastroLoading) {
        commit('SET_CADASTRO_LOADING', true);
        http
          .get('usuario/info')
          .then((resp) => {
            commit('SET_CADASTRO_LOADING');
            commit('SET_CADASTRO_ERROR');
            commit('SET_USUARIO_INFO', resp.data.data);
            resolve();
          })
          .catch(function (error) {
            commit('SET_CADASTRO_LOADING');
            commit('SET_CADASTRO_ERROR', error.response.data);
            reject();
          });
      }
      resolve();
    });
  },
  async loadCep({ commit }, value) {
    commit('SET_LOADING_CEP', true);

    const zip_code = value.trim().replace(/[^0-9]/g, '');

    const url_cep = 'https://viacep.com.br/ws/' + zip_code + '/json';

    // clear all headers axios to viacep
    axios.defaults.headers.common = null;

    return axios
      .get(url_cep)
      .then((response) => {
        commit('SET_LOADING_CEP', false);
        return response.data;
      })
      .catch(() => {
        commit('SET_LOADING_CEP', false);
        commit('mensagem', 'CEP não encontrado');
      });
  },

  async loadMunicipios({ commit }, value) {
    commit('SET_LOADING_MUNICIPIOS', true);
    commit('SET_MUNICIPIOS_INFO', []);
    const uf = value.trim().toUpperCase();
    return http
      .get(API_IBGE + '/' + uf + '/municipios/')
      .then((response) => {
        commit('SET_LOADING_MUNICIPIOS', false);
        commit('SET_MUNICIPIOS_INFO', response.data);
      })
      .catch(() => {
        commit('SET_LOADING_MUNICIPIOS', false);
        commit('mensagem', 'Municípios não encontrados');
      });
  },

  async checkNomeUsuario({ commit }, value) {
    if (value === '') {
      commit('SET_NOME_USUARIO_EXISTS', null);
    }
    commit('SET_NOME_USUARIO_LOADING', true);
    return http
      .get('usuario/VerificarNomeUsuario', {
        params: { nomeUsuario: value }
      })
      .then((response) => {
        commit('SET_NOME_USUARIO_LOADING', false);
        commit('SET_NOME_USUARIO_EXISTS', response.data.data);
      })
      .catch(() => {
        commit('SET_NOME_USUARIO_LOADING', false);
        commit('SET_NOME_USUARIO_EXISTS', 'Erro ao buscar nome de usuário');
      });
  },

  async checkNumeroDocumento({ commit }, value) {
    commit('SET_NUMERO_DOCUMENTO_LOADING', true);
    return http
      .get('usuario/VerificarNumeroDocumento', {
        params: { numero: value }
      })
      .then((response) => {
        commit('SET_NUMERO_DOCUMENTO_LOADING', false);
        commit('SET_NUMERO_DOCUMENTO_EXISTS', response.data.data);
      })
      .catch(() => {
        commit('SET_NUMERO_DOCUMENTO_LOADING', false);
      });
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};
